import { ReactNode } from 'react';

interface ClubLayoutProps {
  children: ReactNode;
}

/**
 * Layout component for club-related pages
 * Using solid black theme with full width
 */
export const ClubLayout = ({ children }: ClubLayoutProps) => {
  return (
    <div className="min-h-screen bg-black text-white p-6">
      <div className="w-full">
        {children}
      </div>
    </div>
  );
};